import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
export function SocialProofToast() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show after 5 seconds, then hide after 8 seconds
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 13000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-335">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-slate-900 border border-amber-500/30 rounded-xl p-4 shadow-2xl shadow-amber-500/10 flex items-start gap-3" data-id="element-336">
          <div className="bg-green-500/20 p-2 rounded-full shrink-0" data-id="element-337">
            <CheckCircle2 className="w-5 h-5 text-green-400" data-id="element-338" />
          </div>
          <div className="flex-1 pr-6" data-id="element-339">
            <p className="text-xs text-slate-400 font-medium mb-1" data-id="element-340">
              Compra verificada
            </p>
            <p className="text-sm font-bold text-slate-100" data-id="element-341">
              Claudia M. de Tucumán
            </p>
            <p className="text-xs text-amber-400 mt-0.5" data-id="element-342">
              Compró Nuevo Nivel + Protocolo 30 Días 🏆
            </p>
            <p className="text-[10px] text-slate-500 mt-1" data-id="element-343">Hace 8 minutos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-500 hover:text-slate-300 transition-colors" data-id="element-344">
            <X className="w-4 h-4" data-id="element-345" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}